import styled from 'styled-components'

export const UploaderTitle = styled.h3`
  font-size: 16px;
  font-style: normal;
  line-height: 20px; /* 125% */
  letter-spacing: 0.16px;
`

export const UploaderText = styled.p`
  opacity: 0.6;
  font-feature-settings: 'ss01' on;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.16px;
  margin: 0;
`

export const UploaderErrorText = styled.p`
  color: #ff623e;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 16px;
  margin: 0;
`
